module.exports = __webpack_public_path__ + "static/media/header_schwangerschaft_und_geburt.94668b3c.jpg";